<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <!-- Filter Section Start-->
        <div class="md-layout">
          <!-- Search Term Input -->
          <div class="md-layout-item md-small-size-100 md-size-0">
            <md-field>
              <label for="mtype">Search Term</label>
              <md-input
                name="term"
                id="term"
                v-model="transactionQuery.term"
                @md-selected="targetField('term', $event)"
              ></md-input>
              <!-- <md-icon>search</md-icon> -->
            </md-field>
          </div>
          <!-- Dropdown Filter -->
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Date</label>
              <md-select v-model="dateFilter">
                <md-option value="ALL">All Time</md-option>
                <md-option value="DAY">Last 24 Hours</md-option>

                <md-option value="MONTH">Last 30 Days</md-option>
                <md-option value="YEAR">Last 12 Months</md-option>
                <md-option value="CUSTOM">Custom</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Date From -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.start">
              <label>Date From</label>
            </md-datepicker>
          </div>

          <!-- Date To -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.end">
              <label>Date To</label>
            </md-datepicker>
          </div>
        </div>
        <!-- Filter Section End -->

        <!-- Filter Section: Action Buttons -->
        <div>
          <md-button class="md-raised md-success" @click="filterTransactions()"
            >Filter</md-button
          >

          <md-button class="md-raised md-danger" @click="resetQuery()"
            >Reset</md-button
          >

          <md-button class="md-raised md-primary" @click="exportToExcel()"
            >Export List</md-button
          >
        </div>
        <!-- Filter Section: Action Buttons End -->

        <!-- Table -->
        <md-card>
          <md-card-content>
            <div class="text-right">
              <md-button class="md-primary" @click="addNewCustomer()"
                >+ New Customer</md-button
              >
            </div>
            <div>
              <div>
                 <md-table table-header-color="green" >
                  <!-- Table Row -->
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Date</md-table-head>
                    <md-table-head>Customer Phone</md-table-head>
                    <md-table-head>Customer Name</md-table-head>
                    <md-table-head>Customer Email</md-table-head>
                    <md-table-head>Customer ID</md-table-head>
                    <md-table-head>Customer REF.</md-table-head>
                  </md-table-row>
                  <!-- Empty Data -->
                  <md-table-row v-if="transactions.length < 1">
                    <md-table-cell colspan="9">
                      <p>No record found.</p>
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-for="(transaction, index) in transactions"
                    :key="index"
                    @click="openUserPage(transaction.id)"
                  >
                    <md-table-cell>{{ index + 1 }}</md-table-cell>
                    <md-table-cell md-label="Date">
                      {{ format(transaction.created_at, 'DD/MM/YYYY hh:mm a') }}
                    </md-table-cell>
                    <md-table-cell md-label="Phone Number">
                      {{ transaction.customer.phone }}
                    </md-table-cell>
                    <md-table-cell md-label="Customer Name">
                      {{
                        transaction.customer.name || transaction.customer.phone
                      }}
                    </md-table-cell>
                    <md-table-cell md-label="Email">
                      {{ transaction.customer.email || "N/A" }}
                    </md-table-cell>
                    <md-table-cell
                      md-label="Business Table ID"
                    >
                       {{ transaction.id  }}
                    </md-table-cell>
                    <md-table-cell md-label="Customer Root ID">
                      {{ transaction.customer.id }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <div class="md-center" v-if="transactions.length > 28">
                  <md-button class="md-primary" @click="loadMore()"
                    >Load More</md-button
                  >
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <NewUserModal
      :current="current"
      ref="addnewCustomerModal"
      :loading="loading"
    />
    <ExportModal ref="exportModal" :fields="exportFields" :onStart="fetchMeta" />

    <!-- Snack bar for error messages -->
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { format } from 'date-fns';
import moment from 'moment';
import NewUserModal from './modal/newUserModal.vue';
import ExportModal from '../../components/ExportModal.vue';
import http from '../../utils/Http.util';

export default {
  components: {
    NewUserModal,
    ExportModal,
  },
  watch: {
    dateFilter(view) {
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }
      this.transactionQuery.start = from;
      this.transactionQuery.end = to;
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },
  data() {
    return {
      selected: {},
      testDate: format(new Date(), 'YYYY-MM-DD'),
      dateFilter: 'ALL',
      showDatePicker: false,
      dialog: {
        active: false,
        id: null,
        transactionDetail: { vendResponse: {} },
      },
      snackBar: {
        show: false,
        message: null,
      },
      transactions: [],
      transactionQuery: {
        order_id: '',
        page: 1,
        limit: 30,
        start: null,
        end: null,
        filteredQuery: {},
        checkpoint: null,
        order: JSON.stringify([['created_at', 'DESC']]),
        get created_at() {
          if (this.start && this.end) {
            this.end.setHours(23);
            this.end.setMinutes(59);
            this.end.setSeconds(59);

            return {
              $between: [this.start.toString(), this.end.toString()],
            };
          }

          return { $between: [this.start, this.end] };
        },
      },
      current: null,
      filterQuery: {},
      totalPages: 1,
      loading: false,
      isRequerying: false,
      exportFields: ['id', 'phone', 'name', 'email', 'created_at'],
    };
  },
  methods: {
    async loadView(view) {
      // Pick date from state
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }

      this.transactionQuery.start = from;
      this.transactionQuery.end = to;

      await this.filterTransactions();
    },
    openUserPage(id) {
      this.$router.push(`/customers/details?queryId=${id}`);
    },
    addNewCustomer() {
      this.$refs.addnewCustomerModal.onOpen();
    },
    format,
    async fetchData(page, downloadLimit) {
      const {
        limit, checkpoint, order, filteredQuery,
      } = this.transactionQuery;
      const queryLimit = downloadLimit || limit;
      try {
        const { data } = await http.authReq(
          `/dashboard/customers?checkpoint=${checkpoint}&limit=${queryLimit}&page=${page}&order=${order}`,
          {
            where: filteredQuery,
          },
        );
        return data;
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        return [];
      }
    },
    async fetchMeta(page, downloadLimit) {
      const {
        limit, checkpoint, order, filteredQuery: where,
      } = this.transactionQuery;
      const queryLimit = downloadLimit || limit;

      const { data } = await http.authReq(
        '/dashboard/customers',
        {
          checkpoint,
          limit: queryLimit,
          page,
          order,
          where,
        },
        'get',
      );
      return data;
    },
    async getTransactions() {
      this.$store.commit('busyStatus', true);
      try {
        this.$store.commit('setTransactionQuery', this.transactionQuery);
        const { data } = await http.authReq('/dashboard/customers');
        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    async loadMore() {
      this.$store.commit('busyStatus', true);

      const {
        order,
        checkpoint,
        limit,
        page,
        filteredQuery,
      } = this.transactionQuery;

      const nextPage = page + 1;

      try {
        const { data } = await http.authReq(
          `/dashboard/customers?checkpoint=${checkpoint}&limit=${limit}&page=${nextPage}&order=${order}`,
          {
            where: filteredQuery,
          },
        );

        if (data.length <= 0) {
          this.snackBar = {
            show: true,
            message: 'Nothing more to load.',
          };
        } else {
          this.transactions = [...this.transactions, ...data];

          this.transactionQuery.page = nextPage;

          this.$store.commit('setTransactions', [...this.transactions, ...data]);
        }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }

      this.$store.commit('busyStatus', false);
    },
    async filterTransactions() {
      this.$store.commit('busyStatus', true);

      try {
        const { order, created_at, term } = this.transactionQuery;
        let query = created_at.$between[0] ? { created_at } : {};
        if (term) {
          query = {
            ...query,
            $or: [
              { email: term.trim() },
              { phone: term.trim() },
            ],
          };
        }

        if (Object.keys(this.filterQuery).length > 0) {
          query = {
            ...query,
            ...this.filterQuery,
          };
        }

        const jsonQuery = JSON.stringify(query);

        const { data } = await http.authReq(
          `/dashboard/customers?order=${order}`,
          {
            where: jsonQuery,
          },
        );

        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactionQuery.filteredQuery = jsonQuery;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      } finally {
        this.$store.commit('busyStatus', false);
      }
    },
    targetField(field, data) {
      if (data) {
        this.filterQuery[field] = data;
      } else if (this.filterQuery[field]) {
        delete this.filterQuery[field];
      }
    },
    async resetQuery() {
      this.dateFilter = 'ALL';
      this.showDatePicker = false;
      await this.getTransactions();
      this.filterQuery = {};
      const fields = document.querySelectorAll('.md-input');
      for (let key = 0; key < fields.length; key += 1) {
        fields[key].value = '';
      }
    },

    getExportFileName() {
      const filename = `Customers Export - ${format(Date.now(), 'DD/MM/YYYY hh:mm a')}`;
      return filename;
    },
    exportToExcel() {
      this.$refs.exportModal.open();
    },
  },
  mounted() {
    this.loadView('ALL');
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.md-datepicker {
  z-index: 1 !important;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.close {
  padding: 4px;
  // background: #a3a3a3;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
}
.table-body {
  // width: 100%;
  overflow-x: auto;
  scroll-behavior: auto;
  // max-width: 50%;
}

.md-dialog /deep/.md-dialog-container {
  max-width: 100%;
}
.dropdown {
  span {
    padding: 0 24px !important;
  }
}

.body {
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
.page-btn {
  margin-right: 20px;
  font-size: 20px !important;
}
.dropdown-search {
  width: 90%;
  height: 30px;
  margin: 0 auto;
  margin-bottom: 5px;
  box-shadow: none;
}
</style>
